import React from 'react';

import { connect } from 'react-redux';
import { withRouter, Redirect, RouteComponentProps } from 'react-router';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { jobSelector } from '../../reducers/job-selectors';
import { loadJob } from '../actions/load-job';

import * as WebRoutes from '../../web-routes';

import { LoadingMessage } from '../../widgets/loading-message';

type InputProps = {
  jobId: number;
};

const mapStateToProps = (state: any, ownProps: InputProps) => ({
  job: jobSelector(state, ownProps.jobId),
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<any, any, AnyAction>,
  ownProps: InputProps,
) => ({
  actions: {
    loadJob: () => dispatch(loadJob(ownProps.jobId)),
  },
});

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;

type Props = InputProps & StateProps & DispatchProps & RouteComponentProps;

class LegacyJobRedirectComponent extends React.Component<Props> {
  componentDidMount() {
    this.props.actions.loadJob();
  }

  componentDidUpdate() {
    this.props.actions.loadJob();
  }

  render() {
    const { job, location } = this.props;
    if (!job) {
      return <LoadingMessage />;
    }

    if (!location) {
      return <Redirect to={WebRoutes.jobPageRoute(job.orgId, job.job_id)} />;
    }

    const redirectPath =
      location.pathname.replace(
        WebRoutes.directJobPageRoute(job.job_id),
        WebRoutes.jobPageRoute(job.orgId, job.job_id),
      ) + location.search;

    return <Redirect to={redirectPath} />;
  }
}

export const LegacyJobRedirect = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LegacyJobRedirectComponent),
);
